import "./App.scss";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Main from "./Views/Main";
import Single from "./Views/Single";

function App() {
  return ( 
    <Router basename={'/rent'}>
      <Switch>
        <Route exact path="/" render={(props) => <Main {...props} />}></Route>
        <Route exact path="/:carID" render={(props) => <Single {...props} />}></Route>
      </Switch>
    </Router>
  );
}

export default App;
